module.exports = __webpack_public_path__ + "static/media/icon-stage-milestone-white.2255153a.svg";